export default class Countdown extends HTMLElement {
  type!: string;
  date!: string | null;
  duration!: number;
  persist!: boolean;
  timerId!: string | null;
  targetDate!: number;
  interval: any;

  constructor() {
    super();
  }

  connectedCallback() {
    this.type = this.getAttribute("type") || "fixed";
    this.date = this.getAttribute("date");
    this.duration = parseInt(this.getAttribute("duration") || "0", 10);
    this.persist = this.getAttribute("persist") === "true";
    this.timerId = this.getAttribute("id");

    this.initTargetDate();

    if (!this.targetDate) return;

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  initTargetDate() {
    if (this.type === 'fixed') {
      if (this.date) {
        this.targetDate = new Date(this.date).getTime();
      }
    } else {
      // Duration mode
      const now = new Date().getTime();
      const durationMs = this.duration * 60 * 60 * 1000;

      if (this.persist && this.timerId) {
        const storageKey = `countdown-timer-${this.timerId}`;
        const stored = localStorage.getItem(storageKey);

        if (stored) {
          const storedDate = parseInt(stored, 10);
          // If stored date is in the future, use it
          if (storedDate > now) {
            this.targetDate = storedDate;
            return;
          }
        }

        // Not found or expired, set new
        this.targetDate = now + durationMs;
        localStorage.setItem(storageKey, this.targetDate.toString());
      } else {
        this.targetDate = now + durationMs;
      }
    }
  }

  update() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      this.innerHTML = "00:00:00";
      if (this.interval) clearInterval(this.interval);
      return;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.innerHTML = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  pad(num: number) {
    return num < 10 ? `0${num}` : num;
  }
}
